import axios from 'axios'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'
import { addSign } from './helper'
import { isDuApp } from '@/utils/getDevice'
import Jockeys from '@/utils/jockeys'

const apiMap = {
  // 服务端无跨域，客户端跨域走本地代理
  dev: process.server ? require('../config').devApiProxy : '',
  shft: 'https://shft-asia-east-public.poizon.net',
  shft1: 'https://shft1-asia-east-public.poizon.net',
  itxx: 'https://i-txx-asia-east-public.poizon.net',
  imf1: 'https://i-mf1-asia-east-public.poizon.net',
  imf2: 'https://i-mf2-asia-east-public.poizon.net',
  imf3: 'https://i-mf3-asia-east-public.poizon.net',
  id1: 'https://i-d1-asia-east-public.poizon.net',
  pre: 'https://pre-asia-east-public.poizon.com',
  prod: process.env.API_HOST || 'https://asia-east-public.poizon.com'
}

const needEncryptURLS = [
  '/api/v1/h5/adapter/identify/certificate/orderDetail',
  '/api/v1/h5/adapter/identify/certificate/judgeOrderSource',
  '/api/v1/h5/adapter/center/oversea/get-index-spu-share-detail',
  '/api/v1/h5/adapter/center/oversea/search/v2/order/h5/list',
  '/api/v1/h5/adapter/center/oversea/h5/spu/query-for-user'
]

let loadFlag = true

// 异步加载js
const loadJsPromise = (src) => {
  if (!loadFlag) return
  return new Promise((resolve) => {
    loadFlag = false
    const script = document.createElement('script')
    const head = document.getElementsByTagName('head')[0]
    let loaded
    script.src = src
    script.onload = script.onreadystatechange = function() {
      if (
        !loaded &&
        (!script.readyState || /loaded|complete/.test(script.readyState))
      ) {
        script.onload = script.onreadystatechange = null
        loaded = true
        resolve(loaded)
      }
    }
    script.onerror = function(e) {
      window.DUOTEL &&
        window.DUOTEL.exception(new Error('loadJsPromiseError'), {
          pos: e.target?.src || e.srcElement?.src
        })
    }
    head.appendChild(script)
  })
}

export class Fetch {
  constructor(store) {
    const defaultConfig = {
      headers: {
        appId: 'h5',
        language: store.state.LANG,
        region: store.state.AREA,
        timeZone: `GMT${dayjs().format('Z')}`
      },
      baseURL: apiMap[process.env.customEnv]
    }

    this.store = store
    this.instance = axios.create(Object.assign({}, defaultConfig))
    this.addCommonParams()
    // this.handleCode()
    this.returnData()
    this.handleError()
  }

  addSign(config) {
    const dataKey = config.method === 'get' ? 'params' : 'data'
    delete config[dataKey].sign
    const sign = addSign(config[dataKey])
    config[dataKey].sign = sign
  }

  async handleEncrypt(config) {
    if (typeof window !== 'undefined') {
      // 防爬start
      try {
        if (!window.dw && needEncryptURLS.includes(config.url.split('?')[0])) {
          const link = {
            // pro会把全局的console干掉
            // pro: 'https://davstatic.poizon.com/pgstone.js',
            pro: 'https://davstatic.poizonapp.com/sgpstone.js',
            dev: 'https://davstatic.poizon.com/tgstone.js'
          }
          const isPro = location.host.startsWith('asia')
          await loadJsPromise(isPro ? link.pro : link.dev)
        }
        if (needEncryptURLS.includes(config.url.split('?')[0])) {
          const { a, c, d } = window.dw.Fun110(
            JSON.stringify(
              config.method === 'post' ? config.data : config.params
            ),
            config.method
          )
          if (config.method === 'get') {
            const param = JSON.parse(d)
            Object.keys(config.params).forEach((key) => {
              config.params[key] = encodeURIComponent(param[key])
            })
          } else {
            config.data = JSON.parse(d)
          }
          config.headers = {
            ...config.headers,
            sks: c,
            SK: window.dw.getSk()
          }
          config.a1 = a
        }
      } catch (e) {
        console.error('加密错误', e)
      }
      // 防爬 end
    }
  }

  addCommonParams() {
    this.requestUse(async (config) => {
      const { LANG, AREA } = this.store.state
      const dataKey = config.method === 'get' ? 'params' : 'data'
      config[dataKey] = { ...config[dataKey] }
      config[dataKey] = config[dataKey] ?? {}
      config[dataKey].countryCode = AREA
      config[dataKey].language = LANG
      if (
        process.env.NODE_ENV === 'development' ||
        process.env.customEnv === 'imf1'
      ) {
        // 新增染色环境
        const hasColor = localStorage?.getItem('x-infr-flowtype')
        if (hasColor) {
          config.headers['x-infr-flowtype'] = `CE_${hasColor}`
        }
      }

      await this.addSign(config)
      await this.handleEncrypt(config)
      return config
    })
  }

  // handleCode(res) {
  //   // this.responseUse(
  //   //   (res) => {
  //   const error = new Error()

  //   if (!res) {
  //     error.message = '服务错误'
  //     return Promise.reject(error)
  //   }
  //   if (res.data.code === 700) {
  //     isDuApp && Jockeys.login()
  //     error.message = res.data.msg || '需要登录'
  //     error.code = 700
  //     return Promise.reject(error)
  //   }
  //   if (res.data.code !== 200) {
  //     error.message = res.data.msg || '服务错误'
  //     return Promise.reject(error)
  //   }
  //   return res
  //   // },
  // }

  returnData() {
    this.responseUse((res) => {
      const error = new Error()
      if (!res) {
        error.message = '服务错误'
        return Promise.reject(error)
      }

      if (Object.prototype.toString.call(res.data.data) === '[object Object]') {
        res.data.data._res = {
          code: res.data.code,
          status: res.data.status,
          msg: res.data.msg
        }
      }
      try {
        if (
          typeof window !== 'undefined' &&
          needEncryptURLS.includes(res.config.url.split('?')[0])
        ) {
          const sks = res.config.headers.sks
          const a = res.config.a1
          res.data = JSON.parse(window.dw.Fun99(res.data, a, sks))
        }
      } catch (error) {
        console.error('error', error)
      }

      if (res.data.code === 700) {
        if (res.config.url.endsWith('questionnaire/h5/properties')) {
          return Promise.reject(error)
        }
        if (isDuApp) {
          Cookies.remove('duToken')
          Jockeys.login()
        }
        error.message = res.data.msg || '需要登录'
        error.code = 700
        return Promise.reject(error)
      }

      // res.config.url.endsWith('questionnaire/h5/properties')

      if (
        res.status === 200 &&
        res.config.url.endsWith('pageQueryByCondition')
      ) {
        return res.data
      }

      if (res.data.code !== 200) {
        error.message = res.data.msg || '服务错误'
        return Promise.reject(error)
      }

      console.log('.......res', res)

      return res.data.data
    })
  }

  // 统一处理错误
  handleError() {
    this.responseUse(undefined, (err) => {
      if (process.client) {
        const { toast } = require('@/components/toast')
        if (err.code !== 700 || !isDuApp) toast(err.message)
      }
      // eslint-disable-next-line no-console
      return Promise.reject(err)
    })
  }

  requestUse(...rest) {
    this.instance.interceptors.request.use(...rest)
  }

  responseUse(...rest) {
    this.instance.interceptors.response.use(...rest)
  }
}

export default Fetch
